import {
    CHANGE_PASSWORD_CHALLENGE,
    FEDERATED_LOGIN,
    USER_AVAILABLE,
    USER_LOGIN,
    USER_LOGOUT,
} from '../actions';

import { DefaultAbilities } from '../../Can/ability';

// INITIALIZE STATE
const initialState = {
    user: null,
    abilities: DefaultAbilities,
    loggingIn: false,
    newPasswordChallenge: false,
};

if (initialState.user) {
    window.dispatchEvent(new Event('authenticated'));
}

// REDUCER
export const AuthReducer = (state = initialState, action) => {
    switch (action.type) {
        case `${USER_LOGIN}_PENDING`:
            return {
                ...state,
                loggingIn: true,
                user: null,
                abilities: DefaultAbilities,
            };
        case `${USER_LOGIN}_FULFILLED`:
        case USER_AVAILABLE:
            console.log('original user', action.payload);
            window.dispatchEvent(new Event('authenticated'));

            return {
                ...state,
                loggingIn: false,
                user: action.payload,
                abilities: action.payload.abilities,
            };
        case `${USER_LOGIN}_REJECTED`:
            return {
                ...state,
                loggingIn: false,
                user: null,
                abilities: null,
            };

        case `${USER_LOGOUT}_PENDING`:
            return {
                ...state,
                loggingIn: true,
            };
        case `${USER_LOGOUT}_FULFILLED`:
            localStorage.removeItem('user');

            return {
                ...state,
                loggingIn: false,
                user: null,
                abilities: DefaultAbilities,
            };
        case `${USER_LOGOUT}_REJECTED`:
            return {
                ...state,
                loggingIn: false,
            };

        case FEDERATED_LOGIN:
            console.log('FEDERATED_LOGIN', action);
            localStorage.setItem('user', JSON.stringify(action.payload));
            window.dispatchEvent(new Event('authenticated'));
            return {
                ...state,
                loggingIn: false,
                user: action.payload,
            };
        case CHANGE_PASSWORD_CHALLENGE:
            return {
                ...state,
                loggingIn: false,
                newPasswordChallenge: true,
            };
        case `${CHANGE_PASSWORD_CHALLENGE}_FULFILLED`:
            return {
                ...state,
                loggingIn: false,
                newPasswordChallenge: false,
            };
        default:
            return state;
    }
};
